import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

@Injectable()
export class ChatbotHostService {

    constructor(private http: HttpClient) {
    }

    getStaticQuestionnaire(chatBotName) {
        var time = new Date().getTime();
        return this.http.get<any>(`/json/chatbot/${chatBotName}/questionnaire.json?time=${time}`);
    }

    getStaticScript(chatBotName) {
        var time = new Date().getTime();
        return this.http.get<any>(`/json/chatbot/${chatBotName}/script.json?time=${time}`);
    }

    getChatBotDetail(chatBotName) {
        return this.http.get<any>(`/api/ChatbotQuestionnaire/Type/${chatBotName}`);
    }

    saveChatBotResponse(payload) {
        return this.http.post<any>(`/api/ChatBot`, payload);
    }
}
